import { QuestionStatus } from './enums';

/** A root waiting for enrichment, or past it and neither retired nor replaced. */
export const ENRICHABLE_QUESTION_STATUSES: readonly QuestionStatus[] = [
  QuestionStatus.ReadyForEnrichment,
  QuestionStatus.AwaitingReview,
  QuestionStatus.Published,
];

/**
 * A root whose printed question can be re-digitised, which deletes its tree. A
 * published, superseded or retired root is frozen, and a set may hold it.
 */
export const REDIGITISABLE_QUESTION_STATUSES: readonly QuestionStatus[] = [
  QuestionStatus.Draft,
  QuestionStatus.NeedsSolution,
  QuestionStatus.ReadyForEnrichment,
  QuestionStatus.AwaitingReview,
  QuestionStatus.Rejected,
];

/** The range a question's computed difficulty falls in, out of 10. */
export const QUESTION_DIFFICULTY_MIN = 1;
export const QUESTION_DIFFICULTY_MAX = 10;

/**
 * How long a root's last change must stand before a sweep takes the work its
 * status says it is owed, so a sweep leaves alone a root whose send has only
 * just gone.
 */
export const SWEEP_GRACE_MS = 10 * 60 * 1000;
